import { Element, Component, Host, h, Prop, State } from '@stencil/core';
import { projectTemplate } from '../../utils/utils';

@Component({
  tag: 'me-ai-summary-button',
  styleUrl: 'me-ai-summary-button.scss',
  shadow: false,
})
export class MeAiSummaryButton {

  @Element() host: HTMLMeAiSummaryButtonElement;

  @Prop() size = 'r';
  @Prop() articleId = '';
  @Prop() aiGenerated = true;
  @Prop() apiBaseUrl: string = 'https://api.main-echo.de';

  @State() content?: HTMLTemplateElement = null;

  private readonly popover = document.createElement('me-popover');

  render() {
    return (
      <Host>
        <template ref={(el: HTMLTemplateElement) => this.content = el}><slot /></template>
        <me-button size={this.size} theme="neutral-contrast" round={true} onClick={this.togglePopover.bind(this)}>
          <i class="fa-solid fa-align-left" />
        </me-button>
      </Host>
    );
  }

  async togglePopover() {
    if (!this.popover.isConnected) {
      this.configurePopover();
      this.host.appendChild(this.popover);
    }

    await this.popover.toggle(this.host);
  }

  private configurePopover() {
    this.popover.setAttribute(
      'popover-title',
      this.aiGenerated ? 'KI-Zusammenfassung des Artikels' : 'Das Wichtigste in Kürze');

    const column = document.createElement('me-popover-column');
    this.popover.appendChild(column);

    const summary = document.createElement('me-ai-summary');
    column.appendChild(summary);
    summary.setAttribute('article-id', this.articleId);
    summary.setAttribute('ai-generated', this.aiGenerated ? 'true' : 'false');
    summary.setAttribute('api-base-url', this.apiBaseUrl);
    projectTemplate(this.content)(summary);
  }
}
